import React, { Component } from 'react';
import { Form,message, Icon, Input, Button, Row, Col, Spin, Select,  Checkbox } from 'antd';
import { SIGNUP_SUCCESS_MSG } from '../../../../core/constants/constants'
import ReactGA from 'react-ga';
import {Link} from "react-router-dom"
export default class Signup extends Component {
    constructor(props) {
        super(props);
    
        this.state = {
          firstName: '',
          plan:"free",
          lastName: '',
          email: '',
          password: '',
          role: 'student',
          card:{},
          subscription:{},
          loading: false,
          current_period_end:null,
          tos:true,
          status: {
            completed: false
          }
        };
      }
    
      componentWillReceiveProps(nextProps) {
        const { authError, authSuccess,  } = nextProps;
        if (authError) message.error(authError);
        if (authSuccess === SIGNUP_SUCCESS_MSG) {
          message.success(authSuccess)
          window.fbq('track', 'CompleteRegistration');
          ReactGA.event({
            category: 'User',
            action: 'Complete Registration',
            label: 'User Interaction'
          });
        }
      }
    
      handleSubmit = (e)=>{
        e.preventDefault();
        this.props.signUp(this.state);
        }
      typing = (e)=>{
        if(e.target.name === "tos")return this.setState({[e.target.name]: e.target.checked})
        this.setState({ [e.target.name]: e.target.value });
      }
  render(){
    return(
          <div>
        <div className="registration-banner">
        <div className="opacity">
            <div className="container">
                <div className="row">
                    <div className="col-md-5 col-xs-12">
                        <div className="registration-form">
                            {/* <form action="#"> */}
                           
                               <Form
                                className="signup-form"
                                onSubmit={this.handleSubmit}
                                >
                                <h2>Register Now</h2>
                                <p>Create  your account and browse thousand of courses!!</p>
                                <Spin tip="Signing Up..." spinning={this.props.loading}>
                                <div className="form-wrapper">
                                    <h6>First Name</h6>
                                    <input required onChange={this.typing} type="text" name="firstName" placeholder="Your Name" />
                                    <h6>Last Name</h6>
                                    <input required onChange={this.typing} type="text" name="lastName" placeholder="Your Name" />
                                    <h6>Your Email</h6>
                                    <input required type="email" onChange={this.typing} name="email" placeholder="sample@email.com" />
                                    <h6>Password</h6>
                                    <input required name="password" onChange={this.typing} type="password" placeholder="" />
                                    <button className="tran3s hvr-trim">SIGN UP NOW!!</button>
                                </div>
                                </Spin>
                            </Form>
                           
                        </div> 
                    </div>

                    <div className="col-md-7 col-xs-12">
                        <div className="text-wrapper">
                            <h2>We Have More <br/>Than <span className="p-color">{this.props.students}+Student</span> Currently Using Orsity</h2>

                            <ul className="clearfix">
                                <li className="float-left">
                                    <div className="single-box">
                                        <h3><span className="counter">{this.props.blogPost}</span></h3>
                                        <p>Recent news</p>
                                    </div> 
                                </li>
                                <li className="float-left">
                                    <div className="single-box">
                                        <h3><span className="counter">{this.props.students}</span></h3>
                                        <p>Total Students</p>
                                    </div> 
                                </li>
                                <li className="float-left">
                                    <div className="single-box">
                                        <h3><span className="counter">{this.props.courses}</span></h3>
                                        <p>Total Courses</p>
                                    </div> 
                                </li>
                            </ul>
                        </div>
                    </div>
                </div> 
            </div>
        </div> 
    </div> 



    <div className="our-course-styleTwo">
        <div className="container">
            <div className="theme-title text-center">
                <h2>Our Courses</h2>
                <p>Build skills with courses online from world-class universities and companies</p>
            </div> 
            <div className="row">
                <div className="col-md-4 col-xs-6">
                    <div className="single-course">
                        <div className="image">
                            <img src="/img/courses/7.jpg" alt=""/>
                            <div className="opacity">
                                <h5><Link to="/courses" className="tran3s">Software <br/>Development</Link></h5>
                                <p>This is a great introduction to the world of code.</p>
                            </div> 
                        </div>
                    </div>
                </div>
                <div className="col-md-4 col-xs-6">
                    <div className="single-course">
                        <div className="image">
                            <img src="/img/courses/8.jpg" alt=""/>
                            <div className="opacity">
                                <h5><Link to="/courses" className="tran3s"> Web <br/>Development</Link></h5>
                                <p> This path will prepare you to build basic websites and then build interactive web apps.</p>
                            </div> 
                        </div>
                    </div>
                </div>
                <div className="col-md-4 col-xs-6">
                    <div className="single-course">
                        <div className="image">
                            <img src="/img/courses/9.jpg" alt=""/>
                            <div className="opacity">
                                <h5><Link to="/courses" className="tran3s">IOS &amp; Android <br/>Apps Development</Link></h5>
                                <p>Build skills with courses online from world-class universities and companies</p>
                            </div> 
                        </div>
                    </div>
                </div>
                <div className="col-md-4 col-xs-6">
                    <div className="single-course">
                        <div className="image">
                            <img src="/img/courses/10.jpg" alt=""/>
                            <div className="opacity">
                                <h5><Link to="/courses" className="tran3s">Algorithms</Link></h5>
                                <p>No matter your experience level, you'll be writing real, working code in minutes.</p>
                            </div> 
                        </div>
                    </div>
                </div>
                <div className="col-md-4 col-xs-6">
                    <div className="single-course">
                        <div className="image">
                            <img src="/img/courses/11.jpg" alt=""/>
                            <div className="opacity">
                                <h5><Link to="/courses" className="tran3s">Data <br/>Science</Link></h5>
                                <p>Great for anyone trying to use code to be more data-driven.</p>
                            </div> 
                        </div>
                    </div>
                </div>
                <div className="col-md-4 col-xs-6">
                    <div className="single-course">
                        <div className="image">
                            <img src="/img/courses/12.jpg" alt=""/>
                            <div className="opacity">
                                <h5><Link to="/courses" className="tran3s">Database<br/>Admistration</Link></h5>
                                <p>From building websites to analyzing data, the choice is yours. </p>
                            </div> 
                        </div>
                    </div>
                </div>
            </div> 
        </div>
    </div> 
    {/* <div className="theme-counter">
				<div className="count-particles">
  					<span className="js-count-particles">--</span>
				</div>
				<div id="particles-js"></div>
				<div className="opacity">
					<div className="container">
						<div className="row">
							<div className="col-sm-3 col-xs-6">
								<h3><span className="counter">85,873</span>+</h3>
								<p>Students</p>
							</div>
							<div className="col-sm-3 col-xs-6">
								<h3><span className="counter">468</span>+</h3>
								<p>Courses</p>
							</div>
							<div className="col-sm-3 col-xs-6">
								<h3><span className="counter">1,729</span>+</h3>
								<p>Projects</p>
							</div>
							<div className="col-sm-3 col-xs-6">
								<h3><span className="counter">2,560</span>+</h3>
								<p>Ratings</p>
							</div>
						</div>
					</div>
				</div>
			</div>  */}
    </div>
      )
  }
}
